import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  Form,
  Input,
  Radio,
  DatePicker,
  Dropdown,
  Checkbox,
} from "semantic-ui-react";
import { setTest, getTestByAssesment, getTestCreation } from "./api/recruiter";
import { savequestionsheet, saveImagequestion } from "./api/questionsheet";
import api from "../config/axios.js";
// import Swal from "sweetalert2";
import { Button as ChakraButton, useToast } from "@chakra-ui/react";

import { ConsoleLogAction } from "./api/recruiter.js";

import axios from "axios";
import url from "../config/config.json";
import CsvUploader from "./csvUploader.js";
import CreateQuestionsModal from "./questionsGenerator";
import { consumeQuestionGeneratorReopen } from "../lib/questionGeneratorSession";
import CreateQuestionsFromJdModal from "./questionsGeneratorFromJd";
import { useRouter } from "next/router";

function Assesment({
  isJobSettingsModalOpen,
  setIsJobSettingModalOpen,
  isTestSettingsModalOpen,
  setIsTestSettingModalOpen,
  testId,
  userId,
  companyId,
  jobId,
  assessment,
  recruiterId,
  customerId,
  jobRole,
  jobDescription: jobDescriptionFromJob,
}) {
  console.log("Company ID:", companyId);
  const router = useRouter();

  const [questionSheetType, setQuestionSheetType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [testDifficulty, setTestDifficult] = useState("default");
  const [testProficiency, setTestProficiency] = useState("beginner");
  const [testType, setType] = useState("test");
  const [nameTest, setNameTest] = useState("");
  // const [isShowTable, setIsShowTable] = useState(false);
  const [time, setTime] = useState("");
  const [skill, setSkill] = useState("");
  const [skillOptionArray, setSkillOptionArray] = useState([]);
  const [isCalculatorEnabled, setIsCalculatorEnabled] = useState("no"); // Add calculator state
  const [isCampusEnabled, setIsCampusEnabled] = useState(false); // Add campus state
  const [isQuestionsModalOpen, setIsQuestionsModalOpen] = useState(false);
  const [isQuestionsFromJdModalOpen, setIsQuestionsFromJdModalOpen] =
    useState(false);

  useEffect(() => {
    const modal = consumeQuestionGeneratorReopen();
    if (modal === "createQuestions") {
      setIsQuestionsModalOpen(true);
    } else if (modal === "createQuestionsFromJd") {
      setIsQuestionsFromJdModalOpen(true);
    }
  }, []);

  const [tokenExpiration, setTokenExpiration] = useState("");
  const [imageFolderName, setImageFolderName] = useState("");
  const [totalMcqQuestion, setTotalMcqQuestion] = useState(0);
  const [totalMriQuestion, setTotalMriQuestion] = useState(0);
  const [totalFillBlanksQuestion, setTotalFillBlanksQuestion] = useState(0);
  const [totalDescriptiveQuestion, setTotalDescriptiveQuestion] = useState(0);
  const [totalCodingQuestion, setTotalCodingQuestion] = useState(0);
  const [easyMcqCount, setEasyMcqCount] = useState(0);
  const [mediumMcqCount, setMediumMcqCount] = useState(0);
  const [hardMcqCount, setHardMcqCount] = useState(0);

  const [easyMriCount, setEasyMriCount] = useState(0);
  const [mediumMriCount, setMediumMriCount] = useState(0);
  const [hardMriCount, setHardMriCount] = useState(0);

  const [easyFillBlanksCount, setEasyFillBlanksCount] = useState(0);
  const [mediumFillBlanksCount, setMediumFillBlanksCount] = useState(0);
  const [hardFillBlanksCount, setHardFillBlanksCount] = useState(0);

  const [easyDescriptiveCount, setEasyDescriptiveCount] = useState(0);
  const [mediumDescriptiveCount, setMediumDescriptiveCount] = useState(0);
  const [hardDescriptiveCount, setHardDescriptiveCount] = useState(0);

  const [easyCodingCount, setEasyCodingCount] = useState(0);
  const [mediumCodingCount, setMediumCodingCount] = useState(0);
  const [hardCodingCount, setHardCodingCount] = useState(0);
  const [filetype, setFileType] = useState("csv");
  const [isLoadingFiles, setIsLoadingFiles] = useState(false);
  const [csvFilesList, setCsvFilesList] = useState([]);
  const [selectedCsvFile, setSelectedCsvFile] = useState("");
  const [fileError, setFileError] = useState(null);
  const [isAutoPopulated, setIsAutoPopulated] = useState(false);
  const [baseUploadResponse, setBaseUploadResponse] = useState(null);

  // const [csv_file, setCsv_file] = useState();

  const [csvFile, setCsvFile] = useState(null);
  const [zipFile, setZipFile] = useState(null);
  const [nameTestError, setNameTestError] = useState(false);
  const [timeError, setTimeError] = useState(false);
  const [isSettingsSaved, setIsSettingsSaved] = useState(false);
  const toast = useToast();
  const handleFileSet = (e) => {
    e.preventDefault();
    setSelectedFile(e.target.files[0]);
  };

  const [Id, setId] = useState();
  const [Idtype, setIdType] = useState();
  const [Action, setAction] = useState();
  const [logactionsend, setLogActionSend] = useState(false);

  const [logresponse, setLogResponse] = useState(null);

  const [errorResponse, setErrorResponse] = useState(null);

  const [useriddata, setUserIdData] = useState(null);

  const [usertypedata, setUserTypeData] = useState(null);

  const handleMcqCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalMcqQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 1; // 1 minute per MCQ question

    setTotalMcqQuestion(newValue); // Store raw input value
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleMriCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalMriQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 1; // 1 minute per MRI question

    setTotalMriQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleFillBlanksCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalFillBlanksQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 1; // 1 minute per Fill Blanks question

    setTotalFillBlanksQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleDescriptiveCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalDescriptiveQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 3; // 3 minutes per Descriptive question

    setTotalDescriptiveQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  const handleCodingCountChange = (e) => {
    const newValue = e.target.value;
    const oldCount = parseInt(totalCodingQuestion) || 0;
    const newCount = parseInt(newValue) || 0;
    const timeDiff = (newCount - oldCount) * 5; // 5 minutes per Coding question

    setTotalCodingQuestion(newValue);
    setTime((prev) => {
      const prevTime = parseInt(prev) || 0;
      return (prevTime + timeDiff).toString();
    });
  };

  useEffect(() => {
    if (jobId) {
      fetchTestSettings();
      fetchCalculatorSettings();
    }
  }, [jobId, assessment]);

  {
    /* New Changes Start */
  }
  // Add calculator settings fetch function
  async function fetchCalculatorSettings() {
    if (!testId && !jobId) return;

    const id = testId || jobId;

    try {
      const response = await api.get(`/get_calculater_flag?test_id=${id}`);
      if (response.data && response.data.calculater) {
        setIsCalculatorEnabled(response.data.calculater);
      }
    } catch (error) {
      console.error("Error fetching calculator settings:", error);
      // Default to "no" if there's an error
      setIsCalculatorEnabled("no");
    }
  }

  async function fetchTestSettings() {
    const jobSettingsResult = await getTestByAssesment(jobId, assessment);

    if (jobSettingsResult && jobSettingsResult.test_info) {
      const {
        test_name,
        difficulty,
        proficiency,
        total_mcq_question,
        total_mri_question,
        total_fill_blanks_question,
        total_descriptive_question,
        total_coding_question,
        total_time,
        topics,
        easy_mcq_count,
        medium_mcq_count,
        hard_mcq_count,
        easy_mri_count,
        medium_mri_count,
        hard_mri_count,
        easy_fill_blanks_count,
        medium_fill_blanks_count,
        hard_fill_blanks_count,
        easy_descriptive_count,
        medium_descriptive_count,
        hard_descriptive_count,
        easy_coding_count,
        medium_coding_count,
        hard_coding_count,
        test_subscription_type,
        token_expiration_date,
        campus = false, // Add campus parameter with default false
      } = jobSettingsResult.test_info;

      //field to disable submit button
      const { test_settings_created } = jobSettingsResult.test_info;
      // console.log("HEY", jobSettingsResult.test_info);

      if (test_settings_created === true) setIsSettingsSaved(true);
      const topicsArray = topics ? topics.split(",") : [];
      setNameTest(test_name);
      setType("test");
      setQuestionSheetType(topics);
      setTestDifficult(difficulty);
      setTestProficiency(proficiency);
      setTotalMcqQuestion(total_mcq_question || 0);
      setTotalMriQuestion(total_mri_question || 0);
      setTotalFillBlanksQuestion(total_fill_blanks_question || 0);
      setTotalDescriptiveQuestion(total_descriptive_question || 0);
      setTotalCodingQuestion(total_coding_question || 0);
      setEasyMcqCount(easy_mcq_count || 0);
      setMediumMcqCount(medium_mcq_count || 0);
      setHardMcqCount(hard_mcq_count || 0);
      setEasyMriCount(easy_mri_count || 0);
      setMediumMriCount(medium_mri_count || 0);
      setHardMriCount(hard_mri_count || 0);
      setEasyFillBlanksCount(easy_fill_blanks_count || 0);
      setMediumFillBlanksCount(medium_fill_blanks_count || 0);
      setHardFillBlanksCount(hard_fill_blanks_count || 0);
      setEasyDescriptiveCount(easy_descriptive_count || 0);
      setMediumDescriptiveCount(medium_descriptive_count || 0);
      setHardDescriptiveCount(hard_descriptive_count || 0);
      setEasyCodingCount(easy_coding_count || 0);
      setMediumCodingCount(medium_coding_count || 0);
      setHardCodingCount(hard_coding_count || 0);
      setTokenExpiration(token_expiration_date || "");
      // console.log("TotalTime", total_time);
      const timeString = parseInt(total_time.split(":")[1]);

      setTime(timeString);
      setSkill(topics);
      setSkillOptionArray([...topicsArray]);
      setIsCampusEnabled(campus); // Set campus state
    } else {
      setNameTest("");
      setType("");
      setQuestionSheetType("");
      setTestDifficult("");
      setTestProficiency("");
      setTotalMcqQuestion(0);
      setTotalMriQuestion(0);
      setTotalFillBlanksQuestion(0);
      setTotalDescriptiveQuestion(0);
      setTotalCodingQuestion(0);
      setEasyMcqCount(0);
      setMediumMcqCount(0);
      setHardMcqCount(0);
      setEasyMriCount(0);
      setMediumMriCount(0);
      setHardMriCount(0);
      setEasyFillBlanksCount(0);
      setMediumFillBlanksCount(0);
      setHardFillBlanksCount(0);
      setEasyDescriptiveCount(0);
      setMediumDescriptiveCount(0);
      setHardDescriptiveCount(0);
      setEasyCodingCount(0);
      setMediumCodingCount(0);
      setHardCodingCount(0);
      setTime("");
      setSkill("");
      setIsSettingsSaved(false);
      setTokenExpiration("");
      setIsCampusEnabled(false); // Reset campus setting
      setIsCalculatorEnabled("no"); // Reset calculator setting
    }
  }

  const skillOptions = [
    { key: "ai_ml", text: "Ai_Ml", value: "ai_ml" },
    { key: "angular", text: "angular", value: "angular" },
    { key: "css", text: "css", value: "css" },
    { key: "design", text: "design", value: "design" },
    { key: "ember", text: "ember", value: "ember" },
    { key: "html", text: "HTML", value: "html" },
    { key: "ia", text: "Information Architecture", value: "ia" },
    { key: "javascript", text: "Javascript", value: "javascript" },
    { key: "mech", text: "Mechanical Engineering", value: "mech" },
    { key: "meteor", text: "Meteor", value: "meteor" },
    { key: "node", text: "NodeJS", value: "node" },
    { key: "python", text: "Python", value: "python" },
    { key: "rails", text: "Rails", value: "rails" },
    { key: "react", text: "React", value: "react" },
    { key: "ruby", text: "Ruby", value: "ruby" },
    { key: "ui", text: "UI Design", value: "ui" },
    { key: "ux", text: "User Experience", value: "ux" },
  ];

  const handleSkillsChange = (e, value) => {
    let skillsArray = [...value];
    if (skillsArray && skillsArray.length) {
      const skillsString = skillsArray.toString();
      setSkill(skillsString);
      // const skillObjArray = [];
      //
      // skillsArray.forEach((_skill) => [
      //   skillObjArray.push({ key: _skill, text: _skill, value: _skill }),
      // ]);

      setSkillOptionArray([...skillsArray]);
    } else {
      setSkillOptionArray([]);
    }
  };

  const preferredLocationOptions = [
    { key: "Delhi NCR", text: "Delhi NCR", value: "Delhi NCR" },
    { key: "Mumbai", text: "Mumbai", value: "Mumbai" },
    {
      key: "Bangalore/Bengaluru",
      text: "Bangalore/Bengaluru",
      value: "Bangalore/Bengaluru",
    },
    { key: "Hyderabad", text: "Hyderabad", value: "Hyderabad" },
    { key: "Chennai", text: "Chennai", value: "Chennai" },
    { key: "Kolkata", text: "Kolkata", value: "Kolkata" },
    { key: "Pune", text: "Pune", value: "Pune" },
    { key: "Lucknow", text: "Lucknow", value: "Lucknow" },
    { key: "Chandigarh", text: "Chandigarh", value: "Chandigarh" },
    { key: "Remote/WFH", text: "Remote/WFH", value: "Remote/WFH" },
    { key: "Any Location", text: "Any Location", value: "Any Location" },
  ];
  const [availability, setAvailability] = useState("");

  console.log("💡 recruiter id  in component:", userId);
  const handleTestSettings = async (e) => {
    e.preventDefault();

    if (nameTest === "") {
      setNameTestError(true);
    } else {
      setNameTestError(false);
    }

    if (time === "") {
      setTimeError(true);
    } else {
      setTimeError(false);
    }

    if (nameTest === "" || time === "") {
      return;
    }

    const testSettings = {
      test_name: nameTest,
      job_id: jobId,
      difficulty: testDifficulty,
      proficiency: testProficiency,
      total_mcq_question: totalMcqQuestion,
      total_mri_question: totalMriQuestion,
      total_fill_blanks_question: totalFillBlanksQuestion,
      total_descriptive_question: totalDescriptiveQuestion,
      total_coding_question: totalCodingQuestion,
      total_time: time,
      topics: skill,
      easy_mcq_count: easyMcqCount,
      medium_mcq_count: mediumMcqCount,
      hard_mcq_count: hardMcqCount,
      easy_mri_count: easyMriCount,
      medium_mri_count: mediumMriCount,
      hard_mri_count: hardMriCount,
      easy_fill_blanks_count: easyFillBlanksCount,
      medium_fill_blanks_count: mediumFillBlanksCount,
      hard_fill_blanks_count: hardFillBlanksCount,
      easy_descriptive_count: easyDescriptiveCount,
      medium_descriptive_count: mediumDescriptiveCount,
      hard_descriptive_count: hardDescriptiveCount,
      easy_coding_count: easyCodingCount,
      medium_coding_count: mediumCodingCount,
      hard_coding_count: hardCodingCount,
      recruiter_id: recruiterId, // ✅ Use recruiterId instead of userId
      company_id: companyId,
      test_subscription_type: testType,
      test_settings_created: true,
      assessment: assessment,
      token_expiration_date: tokenExpiration,
      image_folder_name: imageFolderName,
      campus: isCampusEnabled,
    };

    try {
      if (!testSettings.token_expiration_date) {
        toast({
          title: "Please select token expiration date!",
          status: "error",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
        return false;
      }

      // First, create/update the job-linked test using setTest
      const res = await setTest({
        ...testSettings,
        recruiter_id: recruiterId, // Use recruiterId instead of userId
      });

      // After creating the test, fetch it to get the generated test_id
      let createdTestId = testId;
      try {
        const jobTestResult = await getTestByAssesment(jobId, assessment);
        if (jobTestResult?.test_info?.test_id) {
          createdTestId = jobTestResult.test_info.test_id;
        }
      } catch (fetchError) {
        console.error("Error fetching test for calculator flag:", fetchError);
      }

      // Set calculator flag if we have a valid test id
      if (createdTestId) {
        try {
          await api.post("/set_calculater_flag", {
            test_id: createdTestId,
            calculater: isCalculatorEnabled,
          });
        } catch (calculatorError) {
          console.error("Error setting calculator flag:", calculatorError);
        }
      }

      setIsSettingsSaved(true);
      toast({
        title: "Test created successfully!",
        status: "success",
        position: "top",
        isClosable: true,
        duration: 2000,
      });
    } catch (error) {
      const statusCode = error?.response?.status;
      const errorMessage =
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        error?.message ||
        "An unexpected error occurred";

      if (statusCode === 400) {
        if (
          errorMessage ===
            "Assessment limit exceeded. Cannot create a new test." ||
          errorMessage === "Training limit exceeded. Cannot create a new test." ||
          errorMessage.includes("Assessment limit exceeded") ||
          errorMessage.includes("Training limit exceeded")
        ) {
          toast({
            title: "Error",
            description: (
              <div>
                {errorMessage}
                <ChakraButton
                  size="sm"
                  colorScheme="blue"
                  onClick={async () => {
                    toast.closeAll();
                    try {
                      // Match TestSettingModal behavior
                      if (!customerId || customerId === 0) {
                        const response = await api.post("/add_customer", {
                          customer_name: "",
                          mob_no: "",
                          email_id: "",
                        });

                        if (
                          response?.data &&
                          response.data.customer_id
                        ) {
                          router.push(
                            `/pricing?customer_id=${response.data.customer_id}&pricing=2`
                          );
                        } else {
                          throw new Error("No customer ID received");
                        }
                      } else {
                        router.push(
                          `/pricing?customer_id=${customerId}&pricing=2`
                        );
                      }
                    } catch (renewError) {
                      console.error("Renew error details:", renewError);
                      toast({
                        title: "Unable to process request",
                        description: "Please try again later",
                        status: "error",
                        position: "top",
                        isClosable: true,
                        duration: 3000,
                      });
                    }
                  }}
                >
                  Renew Now
                </ChakraButton>
              </div>
            ),
            status: "error",
            position: "top",
            isClosable: true,
            duration: 5000,
          });
          return;
        }

        toast({
          title: "Error",
          description: errorMessage,
          status: "error",
          position: "top",
          isClosable: true,
          duration: 5000,
        });
        return;
      }

      toast({
        title: "An error occurred",
        description: errorMessage,
        status: "error",
        position: "top",
        isClosable: true,
        duration: 3000,
      });
    }
  };

  const fetchCsvFiles = async () => {
    setIsLoadingFiles(true);
    try {
      const formData = new FormData();
      formData.append("company_id", companyId);

      const response = await api.post("/list_csv_files", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      console.log("API Response:", response.data); // Debug log

      // Check if response.data.files exists and is an array
      if (Array.isArray(response.data.files)) {
        const fileOptions = response.data.files.map((file, index) => {
          const displayName = file
            .replace(/__/g, " ")
            .replace(/\s*\(\d+\)$/, "")
            .replace(/_/g, " ")
            .trim();

          return {
            key: String(index), // Convert to string to ensure compatibility
            text: displayName,
            value: file,
          };
        });

        console.log("Processed Options:", fileOptions); // Debug log
        setCsvFilesList(fileOptions);
      } else {
        console.error("No files array in response:", response.data);
        setCsvFilesList([]); // Set empty array if no files
      }
    } catch (error) {
      console.error("Error fetching CSV files:", error);
      setCsvFilesList([]); // Set empty array on error
    } finally {
      setIsLoadingFiles(false);
    }
  };

  useEffect(() => {
    fetchCsvFiles();
  }, []);

  useEffect(() => {
    if (companyId) {
      console.log("Company ID:", companyId); // Log the companyId
      fetchCsvFiles(); // Call the function only if companyId is available
    }
  }, [companyId]);

  const handleCsvFileSelection = async (fileName) => {
    setSelectedCsvFile(fileName); // Update selected file
    try {
      const response = await api.post("/fetch_test_details", {
        file_name: fileName,
        company_id: companyId,
      });
      console.log("API Response:", response.data);

      // Extract question counts for time calculation
      const mcqCount = response.data.total_mcq_count || 0;
      const mriCount = response.data.total_mri_count || 0;
      const fillBlanksCount = response.data.total_fill_blanks_count || 0;
      const descriptiveCount = response.data.total_descriptive_count || 0;
      const codingCount = response.data.total_coding_count || 0;

      // Calculate total time based on question counts
      const calculatedTime =
        (mcqCount + mriCount + fillBlanksCount) * 1 + // 1 minute each
        descriptiveCount * 3 + // 3 minutes each
        codingCount * 5; // 5 minutes each
      setNameTest(response.data.test_name || "");
      setTotalMcqQuestion(mcqCount);
      setTotalMriQuestion(mriCount);
      setTotalFillBlanksQuestion(fillBlanksCount);
      setTotalDescriptiveQuestion(descriptiveCount);
      setTotalCodingQuestion(codingCount);
      setTime(calculatedTime.toString());
      setSkill(fileName); // Assuming you want to set the file name as skill

      // Set difficulty level counts with null checks
      setEasyMcqCount(response.data.easy_mcq_count || 0);
      setMediumMcqCount(response.data.medium_mcq_count || 0);
      setHardMcqCount(response.data.hard_mcq_count || 0);

      setEasyMriCount(response.data.easy_mri_count || 0);
      setMediumMriCount(response.data.medium_mri_count || 0);
      setHardMriCount(response.data.hard_mri_count || 0);

      setEasyFillBlanksCount(response.data.easy_fill_blanks_count || 0);
      setMediumFillBlanksCount(response.data.medium_fill_blanks_count || 0);
      setHardFillBlanksCount(response.data.hard_fill_blanks_count || 0);

      setEasyDescriptiveCount(response.data.easy_descriptive_count || 0);
      setMediumDescriptiveCount(response.data.medium_descriptive_count || 0);
      setHardDescriptiveCount(response.data.hard_descriptive_count || 0);

      setEasyCodingCount(response.data.easy_coding_count || 0);
      setMediumCodingCount(response.data.medium_coding_count || 0);
      setHardCodingCount(response.data.hard_coding_count || 0);

      setIsAutoPopulated(true);

      toast({
        title: "CSV file processed successfully!",
        status: "success",
        position: "top",
        isClosable: true,
        duration: 2000,
      });
    } catch (error) {
      console.error("Error fetching test details:", error);
      setFileError("Failed to fetch test details. Please try again.");
      toast({
        title: "Error fetching file details",
        description: error.message,
        status: "error",
        position: "top",
        isClosable: true,
        duration: 2000,
      });
    }
  };

  const handleCsvFileUpload = (event) => {
    setCsvFile(event.target.files[0]);
  };

  const handleZipFileUpload = (event) => {
    const file = event.target.files[0];
    setZipFile(file);

    // Extract the folder name from the zip file name (without extension)
    if (file) {
      const fileName = file.name;
      const folderName = fileName.substring(0, fileName.lastIndexOf("."));
      setImageFolderName(folderName);
      console.log("Set image folder name to:", folderName);
    }
  };

  const handleQestionUpload = async () => {
    if (csvFile) {
      const fileName = csvFile.name;
      const sheetName = fileName.substring(0, fileName.lastIndexOf("."));

      try {
        const response = await savequestionsheet(csvFile, sheetName, companyId);
        setBaseUploadResponse(response);

        const mcqCount = response.total_mcq_count || 0;
        const mriCount = response.total_mri_count || 0;
        const fillBlanksCount = response.total_fill_blanks_count || 0;
        const descriptiveCount = response.total_descriptive_count || 0;
        const codingCount = response.total_coding_count || 0;

        const calculatedTime =
          (mcqCount + mriCount + fillBlanksCount) * 1 +
          descriptiveCount * 3 +
          codingCount * 5;

        setNameTest(response.test_name || "");
        setTotalMcqQuestion(mcqCount);
        setTotalMriQuestion(mriCount);
        setTotalFillBlanksQuestion(fillBlanksCount);
        setTotalDescriptiveQuestion(descriptiveCount);
        setTotalCodingQuestion(codingCount);
        setTime(calculatedTime.toString());
        setSkill(sheetName);

        setEasyMcqCount(response.easy_mcq_count || 0);
        setMediumMcqCount(response.medium_mcq_count || 0);
        setHardMcqCount(response.hard_mcq_count || 0);

        setEasyMriCount(response.easy_mri_count || 0);
        setMediumMriCount(response.medium_mri_count || 0);
        setHardMriCount(response.hard_mri_count || 0);

        setEasyFillBlanksCount(response.easy_fill_blanks_count || 0);
        setMediumFillBlanksCount(response.medium_fill_blanks_count || 0);
        setHardFillBlanksCount(response.hard_fill_blanks_count || 0);

        setEasyDescriptiveCount(response.easy_descriptive_count || 0);
        setMediumDescriptiveCount(response.medium_descriptive_count || 0);
        setHardDescriptiveCount(response.hard_descriptive_count || 0);

        setEasyCodingCount(response.easy_coding_count || 0);
        setMediumCodingCount(response.medium_coding_count || 0);
        setHardCodingCount(response.hard_coding_count || 0);

        setIsAutoPopulated(true);

        toast({
          title: "CSV file uploaded successfully!",
          status: "success",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      } catch (error) {
        console.error("Error uploading CSV file:", error);
        toast({
          title: "Error uploading file",
          description: error.message,
          status: "error",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      }
    }

    if (zipFile) {
      const zipFormData = new FormData();
      zipFormData.append("zipfile", zipFile);
      zipFormData.append("company_id", companyId);

      if (imageFolderName) {
        zipFormData.append("folder_name", imageFolderName);
      }

      try {
        const imageResponse = await saveImagequestion(zipFormData, testId);
        console.log("Image upload response:", imageResponse);

        if (
          imageResponse &&
          (imageResponse.status ===
            "File saved, extracted, and zipped successfully!" ||
            imageResponse.status === "success" ||
            imageResponse.message === "success")
        ) {
          toast({
            title: "Zip file uploaded successfully!",
            status: "success",
            position: "top",
            isClosable: true,
            duration: 2000,
          });
        } else {
          toast({
            title: "Zip file processed",
            description: "The file was processed, but check for any issues",
            status: "info",
            position: "top",
            isClosable: true,
            duration: 2000,
          });
        }
      } catch (error) {
        console.error("Error uploading ZIP file:", error);
        toast({
          title: "Error uploading image zip file",
          description: error.message || "Failed to upload zip file",
          status: "error",
          position: "top",
          isClosable: true,
          duration: 2000,
        });
      }
    }
  };

  //new changes [Log Action]
  useEffect(() => {
    const fetchData = async () => {
      try {
        const baseUrl = url.baseUrl;
        const logActionUrl = `${baseUrl}/log_action`;

        const useriddata = JSON.parse(sessionStorage.getItem("userId"));
        setUserIdData(useriddata);

        const usertypedata = JSON.parse(sessionStorage.getItem("userType"));
        setUserTypeData(usertypedata);

        const formData = [
          { key: "id_type", value: usertypedata },
          { key: "id", value: useriddata },
          { key: "action", value: "Job Assessment Created Successfully" },
        ];

        // Convert formData to x-www-form-urlencoded format
        const data = new URLSearchParams();
        formData.forEach(({ key, value }) => {
          data.append(key, value);
        });

        // Make the POST request
        const consoleresponse = await axios.post(logActionUrl, data);
        setLogResponse(consoleresponse.data);
      } catch (error) {
        console.error("Error:", error.message);

        // If there's an error, update the action to "Error in login"
        const formDataError = [
          { key: "id_type", value: usertypedata },
          { key: "id", value: useriddata },
          { key: "action", value: "Error in job Assement Creation" },
        ];

        // Convert formDataError to x-www-form-urlencoded format
        const dataError = new URLSearchParams();
        formDataError.forEach(({ key, value }) => {
          dataError.append(key, value);
        });

        // Make another POST request to log the error
        const errorResponse = await axios.post(logActionUrl, dataError);
        setErrorResponse(errorResponse.data);
      }
    };

    fetchData();
  }, []);

  const handleTemplateDownload = () => {
    window.location.href = "../assesment template.csv";
  };

  return (
    <>
      <Modal.Content scrolling>
        <Modal.Description>
          <Form>
            {/* Select Existing Assessment row */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                marginBottom: "15px",
              }}
            >
              <label style={{ width: "180px", fontWeight: "bold" }}>
                Select Existing Assessment
              </label>
              <div style={{ flex: 1 }}>
                <Dropdown
                  placeholder="Click to see existing assessments"
                  fluid
                  selection
                  loading={isLoadingFiles}
                  options={csvFilesList || []}
                  value={selectedCsvFile}
                  onChange={(e, { value }) => {
                    console.log("Selected value:", value);
                    handleCsvFileSelection(value);
                  }}
                  noResultsMessage="No assessments found"
                />
              </div>
            </div>

            {/* CSV Upload and Template Download */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: "15px",
              }}
            >
              <CsvUploader />
              <div>
                <Button basic color="blue" onClick={handleTemplateDownload}>
                  Download Template
                </Button>
                <Button
                  basic
                  color="green"
                  style={{ marginLeft: "10px" }}
                  onClick={() => setIsQuestionsModalOpen(true)}
                >
                  Generate Questions
                </Button>
                <Button
                  basic
                  color="teal"
                  style={{ marginLeft: "10px" }}
                  onClick={() => setIsQuestionsFromJdModalOpen(true)}
                >
                  Question Generator with JD
                </Button>
              </div>
            </div>

            {/* CSV and Image Assessment row */}
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <div style={{ marginRight: "20px" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  CSV Assessment
                </label>
                <Input
                  type="file"
                  accept=".csv"
                  onChange={handleCsvFileUpload}
                  style={{ width: "350px" }}
                />
              </div>

              <div style={{ marginRight: "20px" }}>
                <label
                  style={{
                    fontWeight: "bold",
                    display: "block",
                    marginBottom: "5px",
                  }}
                >
                  Image Assessment
                </label>
                <Input
                  type="file"
                  accept=".zip"
                  onChange={handleZipFileUpload}
                  style={{ width: "350px" }}
                />
              </div>

              <div style={{ marginTop: "25px" }}>
                <Button
                  color="blue"
                  onClick={handleQestionUpload}
                  disabled={isSettingsSaved}
                >
                  Upload
                </Button>
              </div>
            </div>

            {/* Filename row */}
            <div style={{ display: "flex", marginBottom: "15px" }}>
              <label style={{ width: "100px", fontWeight: "bold" }}>
                Filename
              </label>
              <p>{questionSheetType}</p>
            </div>

            {/* Question count fields */}
            <Form.Group style={{ marginTop: "20px" }}>
              <Form.Field
                required
                control={Input}
                label="Total multiple choice questions"
                type="number"
                min={0}
                value={totalMcqQuestion}
                onChange={handleMcqCountChange}
              />
              <Form.Field
                required
                control={Input}
                label="Total Multiple Response Questions"
                type="number"
                min={0}
                value={totalMriQuestion}
                onChange={handleMriCountChange}
              />
              <Form.Field
                required
                control={Input}
                label="Total Fill Blanks"
                type="number"
                min={0}
                value={totalFillBlanksQuestion}
                onChange={handleFillBlanksCountChange}
              />
              <Form.Field
                required
                control={Input}
                label="Total Descriptive"
                type="number"
                min={0}
                value={totalDescriptiveQuestion}
                onChange={handleDescriptiveCountChange}
              />
              <Form.Field
                required
                control={Input}
                label="Total Coding"
                type="number"
                min={0}
                value={totalCodingQuestion}
                onChange={handleCodingCountChange}
              />
            </Form.Group>

            {/* Difficulty Level */}
            <Form.Group inline>
              <label>Difficulty Level </label>
              <Form.Field
                required
                control={Radio}
                label="Default"
                checked={testDifficulty === "default"}
                onChange={(e) => setTestDifficult("default")}
              />
              <Form.Field
                required
                control={Radio}
                label="Manual"
                checked={testDifficulty === "manual"}
                onChange={(e) => setTestDifficult("manual")}
              />
            </Form.Group>

            {/* Manual Difficulty Fields */}
            {testDifficulty === "manual" && (
              <Form>
                <Form.Group widths="equal">
                  <Form.Field
                    required
                    control={Input}
                    label="Easy multiple choice questions"
                    type="number"
                    min={0}
                    value={easyMcqCount}
                    onChange={(e) => setEasyMcqCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Medium multiple choice questions"
                    type="number"
                    min={0}
                    value={mediumMcqCount}
                    onChange={(e) => setMediumMcqCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Hard multiple choice questions"
                    type="number"
                    min={0}
                    value={hardMcqCount}
                    onChange={(e) => setHardMcqCount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    required
                    control={Input}
                    label="Easy Multiple Response"
                    type="number"
                    min={0}
                    value={easyMriCount}
                    onChange={(e) => setEasyMriCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Medium Multiple Response"
                    type="number"
                    min={0}
                    value={mediumMriCount}
                    onChange={(e) => setMediumMriCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Hard Multiple Response"
                    type="number"
                    min={0}
                    value={hardMriCount}
                    onChange={(e) => setHardMriCount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    required
                    control={Input}
                    label="Easy Fill Blanks"
                    type="number"
                    min={0}
                    value={easyFillBlanksCount}
                    onChange={(e) => setEasyFillBlanksCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Medium Fill Blanks"
                    type="number"
                    min={0}
                    value={mediumFillBlanksCount}
                    onChange={(e) => setMediumFillBlanksCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Hard Fill Blanks"
                    type="number"
                    min={0}
                    value={hardFillBlanksCount}
                    onChange={(e) => setHardFillBlanksCount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    required
                    control={Input}
                    label="Easy Descriptive"
                    type="number"
                    min={0}
                    value={easyDescriptiveCount}
                    onChange={(e) => setEasyDescriptiveCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Medium Descriptive"
                    type="number"
                    min={0}
                    value={mediumDescriptiveCount}
                    onChange={(e) => setMediumDescriptiveCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Hard Descriptive"
                    type="number"
                    min={0}
                    value={hardDescriptiveCount}
                    onChange={(e) => setHardDescriptiveCount(e.target.value)}
                  />
                </Form.Group>

                <Form.Group widths="equal">
                  <Form.Field
                    required
                    control={Input}
                    label="Easy Coding"
                    type="number"
                    min={0}
                    value={easyCodingCount}
                    onChange={(e) => setEasyCodingCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Medium Coding"
                    type="number"
                    min={0}
                    value={mediumCodingCount}
                    onChange={(e) => setMediumCodingCount(e.target.value)}
                  />
                  <Form.Field
                    required
                    control={Input}
                    label="Hard Coding"
                    type="number"
                    min={0}
                    value={hardCodingCount}
                    onChange={(e) => setHardCodingCount(e.target.value)}
                  />
                </Form.Group>
              </Form>
            )}

            {/* Proficiency Level */}
            <Form.Group inline>
              <label>Proficiency </label>
              <Form.Field
                required
                control={Radio}
                label="Beginner"
                checked={testProficiency === "beginner"}
                onChange={(e) => setTestProficiency("beginner")}
              />
              <Form.Field
                required
                control={Radio}
                label="Proficient"
                checked={testProficiency === "proficient"}
                onChange={(e) => setTestProficiency("proficient")}
              />
              <Form.Field
                required
                control={Radio}
                label="Expert"
                checked={testProficiency === "expert"}
                onChange={(e) => setTestProficiency("expert")}
              />
            </Form.Group>

            {/* Test Details */}
            <Form.Group inline>
              <Form.Field
                required
                control={Input}
                label="Test Name"
                placeholder="Name of the Test"
                onChange={(e) => setNameTest(e.target.value)}
                type="text"
                value={nameTest}
                error={nameTestError}
              />
              {nameTestError && (
                <span style={{ color: "red" }}>Please enter the test name</span>
              )}

              <Form.Field
                control={Input}
                label="Total Time"
                placeholder="in mins"
                type="number"
                min={0}
                value={time}
                onChange={(e) => setTime(e.target.value)}
                required
                error={timeError}
              />
              {timeError && (
                <span style={{ color: "red" }}>
                  Please enter the total time
                </span>
              )}

              <div>
                <label>
                  Token Expiration Date <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="date"
                  value={tokenExpiration}
                  required
                  style={{ maxWidth: "15em" }}
                  onChange={(e) => setTokenExpiration(e.target.value)}
                />
              </div>
            </Form.Group>

            {/* Assessment Type */}
            <Form.Group inline>
              <label>Assessment Type</label>
              <Form.Field
                required
                control={Radio}
                label="Test"
                value="test"
                checked={testType === "test"}
                onChange={(e, { value }) => setType(value)}
              />
            </Form.Group>

            {/* Enable Calculator */}
            <Form.Group inline>
              <label>Enable Calculator</label>
              <Form.Field>
                <Checkbox
                  checked={isCalculatorEnabled === "yes"}
                  onChange={(e, data) => {
                    setIsCalculatorEnabled(data.checked ? "yes" : "no");
                  }}
                />
              </Form.Field>
            </Form.Group>

            {/* Enable Campus */}
            <Form.Group inline>
              <label>Enable Campus</label>
              <Form.Field>
                <Checkbox
                  checked={isCampusEnabled}
                  onChange={(e, data) => {
                    setIsCampusEnabled(data.checked);
                  }}
                />
              </Form.Field>
            </Form.Group>
          </Form>
        </Modal.Description>
      </Modal.Content>

      <CreateQuestionsModal
        isOpen={isQuestionsModalOpen}
        onClose={() => setIsQuestionsModalOpen(false)}
        userId={userId}
        companyId={companyId}
      />

      <CreateQuestionsFromJdModal
        isOpen={isQuestionsFromJdModalOpen}
        onClose={() => setIsQuestionsFromJdModalOpen(false)}
        userId={recruiterId || userId}
        companyId={companyId}
        jobId={jobId}
        jobRole={jobRole}
        jobDescription={jobDescriptionFromJob}
      />

      <Button
        style={{ position: "absolute", right: "1em", bottom: "1em" }}
        type="submit"
        content="Submit"
        labelPosition="right"
        icon="checkmark"
        onClick={handleTestSettings}
        positive
        disabled={isSettingsSaved}
      />
    </>
  );
}

export default Assesment;
